import { gsap } from "gsap";
import { Power0 } from 'gsap/all';
import Splide from '@splidejs/splide';
import { AutoScroll } from '@splidejs/splide-extension-auto-scroll';

(function() {
	'use strict'; 

	document.addEventListener('DOMContentLoaded', (event) =>{

		//wait until images, links, fonts, stylesheets, and js is loaded
 		window.addEventListener('load', (e) => {
			
			const carousels = document.querySelectorAll('.carousel-marquee');
			if( carousels ) {
				
				//console.log('Carousels:', carousels, Splide);
				
				//return
				carousels.forEach((element) => {

					const slides = element.querySelectorAll('.splide__slide');

					if( !slides || slides.length <= 0 ) {
						console.error('CAROUSEL MARQUEE CTA');
						return;
					}

					const primarySlider = new Splide( element, {
						//height : '500px',
                        width  : '200px',
						type   : 'loop',
						drag   : false,
						focus  : 'center',
						loop		: true,
						rewind		: true,
						cover      	: false,
						perPage: 1,
						gap: 0,
						padding: 0,
						lazyLoad: false,
						pagination 	: false,
						arrows     	: false,
						autoScroll: {
							speed: .25,
							autoStart: true,
							pauseOnHover: false
						}
					} );

                    
					primarySlider.on( 'ready', function () {
						console.info('CAROUSEL MARQUEE CTA');

                        const tt = setTimeout(()=>{
                            element.style.opacity = 1;
                            clearTimeout(tt);
                        }, 500);
                        
                        /** /
                        slides.forEach((slide)=>{
                          
                            slide.addEventListener('click',(evt)=>{
                                const target =  evt.currentTarget;
                                if( target ) {
                                    const customLink =  target.getAttribute('data-link');
                                    
                                    if( customLink ) {

                                        console.info('SCROLL TO:', customLink);
                                        
                                    }
                                }
                                
                            });
                        });
                        /**/
					} );
                    

					primarySlider.mount({ AutoScroll });
					
					
					
				});
			}

		}, false);

	});

})();
